module.exports = __webpack_public_path__ + "f3e082edab7cc0332d2ade7f77316162.otf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/MyriadPro-It.otf
// module id = 247
// module chunks = 0